<template>
  <div
    class="card"
    @mousedown="onMouseDown"
    @touchstart="onMouseDown"
    @mouseup="onMouseUp"
    @touchend="onMouseUp"
    @mousemove="onMouseMove"
    @touchmove="onMouseMove"
  >
    <header>
      <div class="progress">{{ index }} / {{ totalStatements }}</div>
      <div class="theme">{{ statement.data.theme }}</div>
    </header>

    <figure class="video">
      <MediaVideo
        ref="video"
        :active="active"
        :src="statement.data.video"
        :forcePause="forcePauseVideo"
      />
    </figure>

    <div class="statement">
      {{ statement.data.description }}
    </div>

    <div class="answered" v-if="showPosition">
      {{ chosenLabel }}:
      <div v-if="statement.data.position" class="position thumb-up">
        <img src="images/icons/thumb-up.svg" />
      </div>

      <div v-else class="position thumb-down">
        <img src="images/icons/thumb-down.svg" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import MediaVideo from "@/components/Media/Video";

  export default {
    components: {
      MediaVideo,
    },

    props: {
      statement: Object,
      active: Boolean,
    },

    data: () => ({
      isMouseDown: false,
      forcePauseVideo: false,
    }),

    computed: {
      ...mapState({
        currentStatementIndex: (state) => state.currentStatementIndex,
        totalStatements: (state) => state.totalStatements,
        chosenLabel: (state) => state.dictionary.card.chosen,
      }),

      index() {
        return this.currentStatementIndex + this.statement.index + 1;
      },

      showPosition() {
        return this.statement.data.position === true || this.statement.data.position === false;
      },
    },

    methods: {
      onMouseDown() {
        this.isMouseDown = true;
      },

      onMouseUp() {
        this.isMouseDown = false;
        this.forcePauseVideo = false;
      },

      onMouseMove() {
        if (!this.isMouseDown || this.forcePauseVideo) return;
        this.forcePauseVideo = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    text-align: center;
    color: $blue;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  header {
    @include type-small;
    text-transform: uppercase;
    padding: 15px 25px;
    line-height: 1.3;
    width: 100%;
    text-align: center;

    @media only screen and (orientation: landscape) and (max-height: 720px) {
      font-size: 12px;
      padding: 10px 25px;
    }
  }

  .progress {
    @include type-strong;
  }

  .video {
    padding: 0 10px;
    width: 100%;

    @media only screen and (orientation: landscape) and (max-height: 720px) {
      width: 85%;
    }
  }

  .videoPlaceholder {
    width: 100%;
    padding-bottom: 65.8%;
    position: relative;

    &:after {
      content: "";
      border-radius: $border-radius;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;
      width: 100%;
      background: black;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  
//   @media only screen and (max-width: 375px) {
//     font-size: 16px;
//     line-height: 1.3;
//   }
// }

.statement {
    padding: 0 25px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include type-large;
    @include type-strong;

    @media only screen and (max-height: 900px) {
      font-size: 18px;
    }

    @media only screen and (orientation: landscape) and (max-height: 720px) {
      font-size: 16px;
    }
  }

.answered {
  margin-bottom: 20px;
  display: flex;
  @include type-strong;
}

.position {
    width: 30px;
    height: 30px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;

    @media only screen and (orientation: landscape) and (max-height: 720px) {
      width: 20px;
      height: 20px;
    }

    &.thumb-up {
      background: $green;
    }

    &.thumb-down {
      background: $red;
    }

    img {
      width: 70%;
      height: 70%;
      object-fit: contain;
    }
  }
</style>